import { useMutation, useQueryClient } from '@tanstack/react-query'

import { apiClient } from '../apiClient'
import { OperatorProfileRole, OPERATOR_PROFILE_KEY } from '../operator/useGetProfile'

type UpdateUserRolePayload = {
  userId: string
  role: OperatorProfileRole
}

export function useUpdateUserRole() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ userId, role }: UpdateUserRolePayload) => {
      await apiClient.patch(`/int/v3/users/${userId}/role`, { role })
    },
    onSuccess: (_data, { userId }) => {
      queryClient.invalidateQueries({ queryKey: [OPERATOR_PROFILE_KEY, userId] })
    },
  })
}
